import "@/styles/globals.css";
import { LoadingProvider, useLoading } from "../context/loading";
import { ModalProvider, useModal } from "../context/ModalContext";
import { ATSProvider } from "../context/ATSContext";
import GetAQuoteModal from "../components/quote/GetAQuoteModal";
import { useEffect } from "react";
import { useRouter } from "next/router";
import Layout from "@/components/layout/Layout";
import { Toaster } from "react-hot-toast";
import TawkLoader from "@/components/TawkLoader";

function AppContent({ Component, pageProps }) {
  const { isModalOpen, closeModal } = useModal();
  useEffect(() => {
    const handleScrollAnimations = () => {
      const revealElements = document.querySelectorAll(".reveal-element");

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("revealed");
            }
          });
        },
        { threshold: 0.1, rootMargin: "0px 0px -100px 0px" }
      );

      revealElements.forEach((element) => {
        observer.observe(element);
      });
    };

    handleScrollAnimations();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          handleScrollAnimations();
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Layout>
      <Toaster position="top-right" reverseOrder={false} />
      <Component {...pageProps} />
      <TawkLoader />
      <GetAQuoteModal isOpen={isModalOpen} onClose={closeModal} />
    </Layout>
  );
}

function LoadingWrapper({ children }) {
  const router = useRouter();
  const { startLoading, stopLoading } = useLoading();

  useEffect(() => {
    const handleStart = (url) => {
      const newPath = url.split("?")[0];
      const currentPath = router.pathname;

      // Only show loader if the actual path changes
      if (newPath !== currentPath) {
        startLoading("Loading page...");
      }
    };

    const handleStop = () => {
      stopLoading();
    };

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleStop);
    router.events.on("routeChangeError", handleStop);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleStop);
      router.events.off("routeChangeError", handleStop);
    };
  }, [router.pathname, startLoading, stopLoading]);

  return children;
}


export default function App({ Component, pageProps }) {
  return (
    <LoadingProvider>
      <ModalProvider>
        <ATSProvider>
          <LoadingWrapper>
            <AppContent Component={Component} pageProps={pageProps} />
          </LoadingWrapper>
        </ATSProvider>
      </ModalProvider>
    </LoadingProvider>
  );
}
